import {Component} from 'react'
import ProductListingPage from './components/ProductListingPage'
import './App.css'

class App extends Component {
  render() {
    return (
      <div>
        <ProductListingPage />
      </div>
    )
  }
}

export default App
